module.exports = __webpack_public_path__ + "950a0cdf6268e3873f132ca33c9aadf9.pdf";